import React from 'react';
import { Field, formValueSelector } from 'redux-form/immutable';
import { connect } from 'react-redux';
import classes from './RegistrationForm.scss';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';

import { Checkbox, SelectField, TextField } from 'redux-form-material-ui';

import { Col, Row } from 'react-flexbox-grid';

import { validateConstraints, validationImmutableReduxForm } from '../../../components/FormWrapper';

const formValidation = values =>
    validateConstraints(values.toJS(), {
        tenant_name: {
            format: {
                pattern: '[a-z0-9]+',
                message: '^Bitte nur kleingeschriebene Buchstaben und Zahlen verwenden',
            },
            presence: {
                message: '^Bitte geben Sie einen Mandanten ein',
                allowEmpty: false,
            },
        },
        company: {
            presence: {
                message: '^Bitte geben Sie Ihren Firmennamen ein',
                allowEmpty: false,
            },
        },
        data_format: {
            presence: {
                message: '^Bitte geben Sie Ihr Warenwirtschaftssystem an',
                allowEmpty: false,
            },
        },
        email: {
            presence: {
                message: '^Bitte geben Sie eine gültige E-Mail-Adresse an',
                allowEmpty: false,
            },
            email: {
                message: '^Bitte geben Sie eine gültige E-Mail-Adresse an',
            },
        },
    });

class SimpleForm extends React.Component {
    render() {
        const { handleSubmit, pristine, reset, submitting, accepted_agbs } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <Paper zIndex={1} style={{ paddingBottom: '20px' }}>
                    <div className={classes.form_container}>
                        <Row>
                            <Col xs={8} xsOffset={1}>
                                <h4>Willkommen bei ScanTouch und vielen Dank für Ihr Interesse.</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={8} xsOffset={1}>
                                <p>Über die ScanTouch-Webanwendung können Sie</p>
                                <ul>
                                    <li>Ihre Inventur-Belege herunterladen</li>
                                    <li>
                                        Optional Ihre Artikeldaten hochladen für den Abgleich
                                        während dem Scan
                                    </li>
                                    <li>Ihre Daten und Einstellungen verwalten</li>
                                    <li>
                                        neue Software-Abos bestellen und auch jederzeit stornieren
                                    </li>
                                    <li>Ihre Rechnungen ansehen und herunterladen</li>
                                </ul>
                                <p>Melden Sie sich hier mit Ihren Geschäftsdaten an.</p>
                                <p>
                                    Kosten entstehen erst dann, wenn Sie das erste Software-Abo
                                    aktivieren.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={5} xsOffset={1}>
                                <div>
                                    {this.props.errors.map((error, key) => (
                                        <span
                                            style={{
                                                backgroundColor: '#ff979a',
                                                display: 'block',
                                                padding: '20px',
                                                margin: '20px',
                                            }}>
                                            {error}
                                        </span>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} xsOffset={1}>
                                <Subheader>Firmendaten</Subheader>
                                <Field
                                    name="company"
                                    component={TextField}
                                    type="text"
                                    floatingLabelText="Firma"
                                    style={{ width: '100%' }}
                                    label="Firma"
                                />
                                <br />

                                <Field
                                    name="tenant_name"
                                    component={TextField}
                                    type="text"
                                    style={{ width: '100%' }}
                                    floatingLabelText="Mandant (Kurzname Firma, alphanumerisch und kleingeschrieben)"
                                    label="Mandant (Kurzname Firma)"
                                />
                                <br />
                                <Field
                                    name="data_format"
                                    component={SelectField}
                                    floatingLabelText="Warenwirtschaftssytem">
                                    <MenuItem value="advarics" primaryText="Advarics" />
                                    <MenuItem value="fee" primaryText="FEE" />
                                    <MenuItem value="futura_ers" primaryText="FuturaERS" />
                                    <MenuItem value="futura" primaryText="FuturaRetail" />
                                    <MenuItem value="f2" primaryText="F2000" />
                                    <MenuItem value="h4_f3" primaryText="H5000-H4000-F3000" />
                                    <MenuItem value="intersys5" primaryText="INTERSYS5" />
                                    <MenuItem value="irics" primaryText="IRICS" />
                                    <MenuItem value="neo" primaryText="NEO" />
                                    <MenuItem value="prohandel" primaryText="Prohandel" />
                                    <MenuItem value="wwscsv" primaryText="WWS CSV" />
                                    <MenuItem value="topm_cosys" primaryText="TopM-Cosys" />
                                </Field>
                                <Field
                                    name="first_name"
                                    component={TextField}
                                    type="text"
                                    style={{ width: '100%' }}
                                    floatingLabelText="Vorname"
                                    label="Vorname"
                                />
                                <br />

                                <Field
                                    name="name"
                                    component={TextField}
                                    type="text"
                                    floatingLabelText="Nachname"
                                    style={{ width: '100%' }}
                                    label="Nachname"
                                />
                                <br />

                                <Field
                                    name="email"
                                    component={TextField}
                                    type="text"
                                    style={{ width: '100%' }}
                                    floatingLabelText="E-Mail-Adresse"
                                    label="E-Mail-Adresse"
                                />
                                <br />
                                <br />
                                <br />
                                <a href="https://start.bstools.de/?webapp=true#/module/10432803" target="_blank">
                                    Allgemeine Geschäftsbedingungen BSTools GmbH
                                </a>
                                <br />
                                <br />
                                <a
                                    href="https://start.bstools.de/?webapp=true#/module/11658545"
                                    target="_blank">
                                    Datenschutzerklärung BSTools GmbH
                                </a>
                                <br />
                                <br />
                                <Field
                                    name="accept_agbs"
                                    component={Checkbox}
                                    floatingLabelText="Hiermit bestätige ich die Datenschutzerklärung und die AGBs der BSTools GmbH"
                                    style={{ width: '100%' }}
                                    label="Hiermit bestätige ich die Datenschutzerklärung und die AGBs der BSTools GmbH"
                                />
                            </Col>
                        </Row>
                    </div>
                </Paper>
                <br />
                <Row>
                    <Col xs={12}>
                        <Row end="xs">
                            <Col xs={6}>
                                {accepted_agbs && (
                                    <RaisedButton label="Abschicken" primary={true} type="submit" />
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </form>
        );
    }
}

const selector = formValueSelector('registration'); // <-- same as form name

export default connect(state => {
    return {
        accepted_agbs: selector(state, 'accept_agbs'),
    };
})(validationImmutableReduxForm('registration', formValidation)(SimpleForm));
